import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

import { rhythm } from "../utils/typography"

import MarkdownContent from "../components/markdown"

import { accurateFullArticleTime } from "../utils/utils.js"

function MaybeImage(src) {
  let imageElem
  if (src != "") {
    imageElem = (
      <img
        src={src}
        css={css`
          background-color: #fff;

          margin: 0;

          border: 1px solid #ccc;
        `}
      />
    )
  } else {
    imageElem = (
      <img
        css={css`
          width: 100%;
          padding-top: 50%;
          margin: 0;

          border: 1px solid #ccc;

          background-color: #ffffff;
          background-size: contain;
          background-image: url("placeholder.svg");
        `}
      ></img>
    )
  }
  return imageElem
}

function MaybeStub(frontmatter_stub) {
  if (frontmatter_stub == "true") {
    return (
      <div
        css={css`
          margin-left: -5px;
          display: inline-block;
          font-size: 14px;
          font-weight: 600;
          color: #473dc7;
          background-color: #e0ddf6;
          padding: 1px 5px;
          border-radius: 3px;
        `}
      >
        Short Recommendation
      </div>
    )
  }
}

function ArticleTitle(title) {
  return (
    <div
      css={css`
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        padding-bottom: 2px;
        color: #000;

        margin-bottom: 3px;

        // display: inline;

        // text-decoration: none;

        // position: relative;

        // background-image: linear-gradient(currentColor, currentColor);
        // background-position: 0% 100%;
        // background-repeat: no-repeat;
        // background-size: 0% 2px;
        // transition: background-size 0.25s;

        // :hover {
        //   background-size: 100% 2px;
        // }
      `}
    >
      {title}
    </div>
  )
}

function LastUpdated(date, isInProgress) {
  if (isInProgress) {
    return (
      <div
        css={css`
          margin-left: -5px;
          display: inline-block;
          font-size: 14px;
          font-weight: 600;
          color: #473dc7;
          background-color: #e0ddf6;
          padding: 1px 5px;
          border-radius: 3px;
        `}
      >
        In Progress
      </div>
    )
  } else {
    return (
      <div
        css={css`
          margin-bottom: 3px;
          font-size: 14px;
          font-weight: 600;
          // text-transform: uppercase;
          color: #473dc7;
        `}
      >
        Last Updated {date}
      </div>
    )
  }
}

function ReadingTime(timeToRead, isInProgress, frontmatter_stub) {
  if (isInProgress) {
    return ""
  }
  return (
    <div
      css={css`
        font-size: 12px;
        margin: 0;
        color: #83819a;
        font-weight: 400;
        line-height: 14px;
      `}
    >
      {frontmatter_stub != "true" ? (
        <div
          css={css`
            margin-bottom: 3px;
          `}
        >
          Summary: 1 min read
        </div>
      ) : (
        ""
      )}
      <div>Full guide: {accurateFullArticleTime(timeToRead)} min read</div>
    </div>
  )
}

function ShortDescription(shortDescription) {
  return (
    <div
      css={css`
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #000;

        p {
          margin: 0;
        }

        a {
          font-weight: 600;
          text-decoration: underline;
          color: #bb342f;
        }
      `}
    >
      <MarkdownContent content={shortDescription} />
    </div>
  )
}

function ListArticleCard(props) {
  let isInProgress = props.node.frontmatter.in_progress == "true"
  return (
    <a
      href={props.node.fields.slug}
      css={css`
        margin: -12px -16px;
        padding: 12px 16px;
        text-decoration: none;

        border-width: 1px;
        border-style: solid;
        border-color: transparent;

        transition-duration: 0.08s;
        transition-property: background-color, border-color;

        :hover {
          background-color: #fff;
          border-color: #555;

          box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
        }

        :active {
          background-color: #e0ddf6;
          border-color: #473dc7;
        }

        display: flex;
        gap: 15px;
        max-width: 550px; // hack to fix flicker on load
      `}
    >
      <div
        css={css`
          flex: 1.35;
          max-width: 130px; // hack to fix flicker on load
        `}
      >
        {MaybeImage(props.node.frontmatter.image)}
        {ReadingTime(
          props.node.timeToRead,
          isInProgress,
          props.node.frontmatter.stub
        )}
      </div>

      <div
        css={css`
          flex: 3;
          max-width: 520px; // hack to fix flicker on load
        `}
      >
        <div
          css={css`
            margin-bottom: 8px;
          `}
        >
          {ArticleTitle(props.node.frontmatter.title)}
          {LastUpdated(props.node.frontmatter.date, isInProgress)}
          {MaybeStub(props.node.frontmatter.stub)}
        </div>
        {ShortDescription(props.node.frontmatter.short_description)}
      </div>
    </a>
  )
}

export default ({ props }) => {
  return (
    <div>
      <div
        css={css`
          width: 100%;
          font-family: monospace;
          font-size: 20px;
          padding-bottom: 3px;
          border-bottom: 1px solid #ccc;
          margin-bottom: 24px;
          font-weight: 600;
        `}
      >
        <div
          css={css`
            display: inline-block;
            right: 0;
            margin-top: 5px;
            margin-right: 8px;
            height: 12px;
            width: 12px;
            background-color: #e0ddf6;
          `}
        ></div>
        {props.category}
      </div>
      <div
        css={css`
          display: grid;
          grid-row-gap: 40px;
          width: 100%;
          padding-bottom: 20px;
        `}
      >
        {props.nodes.map(node => ListArticleCard(node))}
      </div>
    </div>
  )
}
